import {
    createSignInSchema,
    createSignUpSchema,
    type SignInFormSchema,
    type SignUpFormSchema,
} from '@fiverr-private/identification_core';

export { createSignInSchema, createSignUpSchema };

export const PASSWORD_VISIBLE_ERROR = 'passwordVisibleError';

export type FormSchema = SignInFormSchema | SignUpFormSchema;
